/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_OriginInputs */

const en_select_origin = /** @type {(inputs: Select_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select origin`)
};

const es_select_origin = /** @type {(inputs: Select_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona origen`)
};

/**
* | output |
* | --- |
* | "Select origin" |
*
* @param {Select_OriginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_origin = /** @type {((inputs?: Select_OriginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_OriginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_origin(inputs)
	return es_select_origin(inputs)
});